import React from 'react';
import { RewardsTileMW, RewardsTileDTW, ExpirationLine, ContainerImageText, MessageNoData, } from '../../../shared/rewards-hub';
import { RewardsAndOffersContext, DrawerContext, InfoPerksContext, } from '../../../../contexts';
import { rhTierRewards, rhGeneral } from '../../../../constants/RewardsHub';
import { fallbackImage } from '../../../../images';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
var constants = rhTierRewards.perkRewards;
var assets = rhGeneral.assets;
export var WellDoneTile = function (_a) {
    var _b;
    var isMobile = _a.isMobile;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var _c = ((_b = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile) === null || _b === void 0 ? void 0 : _b.name) || {}, firstName = _c.firstName, lastName = _c.lastName;
    var name = firstName && lastName && "".concat(firstName, " ").concat(lastName);
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    return (React.createElement(RewardsTile, { title: constants.wellDone, subtitle: name, iconUrl: assets.ProXtraPerks, href: isPacDrawersEnabled ? undefined : rhGeneral.perksPage, isFirstTile: true }));
};
export var NewUnlockedTile = function (_a) {
    var _b;
    var perk = _a.perk, isMobile = _a.isMobile, isFirstTile = _a.isFirstTile;
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    var _c = React.useContext(DrawerContext), openSelectionPerks = _c.openSelectionPerks, onDrawerClose = _c.onDrawerClose, isPacDrawersEnabled = _c.isPacDrawersEnabled;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var eventOutput = {
        tierObj: perk,
        onClose: onDrawerClose,
        programId: (_b = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.program) === null || _b === void 0 ? void 0 : _b.programId,
    };
    var onClick = function () {
        if (isPacDrawersEnabled)
            DrawerEventTriggers.triggerPerkSelectionDrawer(eventOutput);
        else
            openSelectionPerks({ perk: perk, eventOutput: eventOutput });
    };
    return (React.createElement(RewardsTile, { title: constants.newUnlocked, subtitle: React.createElement(ExpirationLine, { perk: perk, type: "Perk" }), iconUrl: assets.badge_unlocked, containerCallback: onClick, isFirstTile: isFirstTile }));
};
export var AvailablePerksTile = function (_a) {
    var perk = _a.perk, isMobile = _a.isMobile, isFirstTile = _a.isFirstTile;
    var _b = React.useContext(DrawerContext), openDetailsPerks = _b.openDetailsPerks, onDrawerClose = _b.onDrawerClose, isPacDrawersEnabled = _b.isPacDrawersEnabled;
    var getDisplayAmount = useDisplayAmount();
    var RewardsTile = isMobile ? RewardsTileMW : RewardsTileDTW;
    var eventOutput = {
        perkObj: perk,
        onClose: onDrawerClose,
    };
    var onClick = function () {
        if (isPacDrawersEnabled)
            DrawerEventTriggers.triggerRewardBarcodeDrawer(eventOutput);
        else
            openDetailsPerks({ perk: perk, eventOutput: eventOutput });
    };
    return (React.createElement(RewardsTile, { title: "".concat(getDisplayAmount(perk)).concat(perk.perkTitle), subtitle: React.createElement(ExpirationLine, { perk: perk, type: "Perk" }), iconUrl: perk.perkImageUrl, containerCallback: onClick, isFirstTile: isFirstTile }));
};
export var NoDataStatePerks = function (_a) {
    var isMobile = _a.isMobile;
    var PerksImage = function () { return (React.createElement("div", { className: "sm:sui-mt-10" },
        React.createElement("img", { src: assets.ProXtraPerks, alt: "Offers", width: isMobile ? '45px' : '86px', height: isMobile ? '45px' : '86px', onError: fallbackImage }))); };
    return isMobile ? (React.createElement(ContainerImageText, { ImageComponent: PerksImage, dimensionsMW: "" },
        React.createElement(MessageNoData, { card: "Perks" }))) : (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
        React.createElement(MessageNoData, { card: "Perks" }),
        React.createElement(PerksImage, null)));
};
